import * as React from "react";
import { Text, View, StyleSheet, Image, TouchableOpacity } from "react-native";

import { useNavigation, StackActions } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { useSelector } from "react-redux";
import { resetCardError } from "../../redux/actions/CardActions";

export default function CardAddErrorNotificationScreen({ route }) {
  const navigation = useNavigation();
  const sparkle = require("../../assets/res/sparkle.png");

  var notificationLoaded = true;
  var message = useSelector((state) => state.card.cardError) || "";
  var buttonText = "BACK";

  React.useEffect(() => {

    return function cleanup() {
      resetCardError()
    }
  })

  return (
    <View style={GlobalStyles.containerMB}>
      {notificationLoaded ? (
        <View style={styles.modalContainerF}>
          <View style={styles.modalContainer}>
            <View style={styles.headerTextP}>
              <View>
                <Text style={styles.textStyleHeaderBig}>
                  Unable to link Card
                </Text>
                <Text style={styles.textStyleHeader}>
                  Card linking is taking longer than expected, please check back
                  shortly to see if it was successful.
                </Text>
                <Text style={styles.textStyleHeader}>
                  If this card is already linked elsewhere it will need to be
                  unlinked first. See FAQs on our website for details or contact
                  support@aura.club for more info.
                </Text>
              </View>
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={styles.SubmitButtonStyle}
                  activeOpacity={0.5}
                  onPress={() => {
                    navigation.dispatch(StackActions.popToTop());
                  }}
                >
                  <Text style={styles.textStyleBack}>{buttonText}</Text>
                </TouchableOpacity>
              </View>
            </View>
            <View>
              <Image style={styles.sparkle} source={sparkle} />
            </View>
          </View>
        </View>
      ) : (
        <></>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  headerTextP: {
    position: "absolute",
    left: 0,
    top: 30,
    paddingLeft: 50,
    paddingRight: 10,
    width: 300,
  },
  modalContainer: {
    height: 400,
    backgroundColor: "#FFFFFF",
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingTop: 30,
    paddingRight: 30,
    paddingLeft: 30,
    width: 330,
  },
  modalContainerF: {
    marginTop: 190,
    paddingRight: 30,
    paddingLeft: 30,
    alignItems: "center",
  },

  textStyleHeader: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 16,
    marginLeft: -15,
    paddingBottom: 12,
  },

  textStyleHeaderBig: {
    color: "#00000",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 24,
    marginLeft: -15,
    paddingBottom: 15,
  },

  sparkle: {
    position: "absolute",
    top: -55,
    right: -55,
    width: 40,
    height: 40,
  },

  SubmitButtonStyle: {
    //marginTop: 10,
    paddingTop: 22,
    paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    borderColor: "#000000",
    borderWidth: 1,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxWidth: "45%",
    alignContent: "center",
  },

  textStyleBack: {
    color: "#000000",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },

  buttonContainer: {
    width: "100%",
    position: "absolute",
    left: 20,
    bottom: -85,
  },
});
